import { environment } from "../../../environments/environment";
import { BackendHealth } from "../models/health-status.model";

// Example default configuration
export const BACKENDS_CONFIG: BackendHealth[] = [
    {
        name: 'Auth Service',
        url: `${environment.authServiceApiBaseUrl}/health`,
        state: 'unknown',
        critical: true
    },
    {
        name: 'User Service',
        url: `${environment.userServiceApiBaseUrl}/health`,
        state: 'unknown',
        critical: true
    },
    {
        name: 'Invoice Service',
        url: `${environment.invoiceServiceApiBaseUrl}/health`,
        state: 'unknown',
        critical: true
    },
    {
        name: 'Communication Service',
        url: `${environment.communicationserviceApiBaseUrl}/health`,
        state: 'unknown',
        critical: true
    }
];